<template>
  <div>
    <el-dialog
      title="指定用户列表"
      class="selections"
      :visible.sync="isOpen"
      :show-close="false"
      :close-on-click-modal="false"
      z-index="1000"
    >
      <el-table
        ref="selections"
        style="width: 100%;"
        border
        v-loading="loading"
        element-loading-text="拼命加载中"
        :data="tableData"
        element-loading-spinner="el-icon-loading"
        :header-row-style="{ 'font-weight': 'bold', 'color': '#9196A0' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
        >
        </el-table-column>
        <el-table-column
          prop="deviceSn"
          label="设备sn号"
        />
      </el-table>
      <div class="paginationBox">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          class="pagination"
        >
        </el-pagination>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleCancel">取 消</el-button>
        <el-button
          type="primary"
          @click="throughUserId"
        >确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import WifiApi from '@/api/wifi.js'
export default {
  props: ['open'],
  data() {
    return {
      isOpen: false,
      loading: false,
      tableData: [],
      ids: "",
      userName: null,
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      selections: [],
    }
  },
  methods: {
    toggleSelection() {
      this.$refs.selections.clearSelection();
    },
    throughUserId() {
      this.$emit('getUserId', this.ids);
      this.isOpen = false;
      this.$emit('closeUserList', this.open);
      this.toggleSelection();
    },
    handleCancel() {
      this.toggleSelection();
      this.isOpen = false;
      this.$emit('closeUserList', this.open);
    },
    // 多选
    handleSelectionChange(val) {
      this.ids = val.map(item => item.deviceSn).join(',');
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getUserFunc();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getUserFunc();
    },
    getUserFunc() {
      this.loading = true;
      const params = {
        state: 1,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
      }
      WifiApi.deviceList({ ...params }).then(res => {
        this.tableData = res.data.records
        this.total = res.data.total
        this.loading = false;
      }).catch(err => {
        this.loading = false;

      })
    },
  },
  mounted() {
    this.getUserFunc()
  },
  watch: {
    open(newVal) {
      this.isOpen = newVal
    }
  }
}
</script>

<style lang="scss" scoped>
:deep .selections {
  .el-table {
    height: 60vh;
    overflow-y: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ybwifi/message/components/UserList.vue